import locale from "@bonliva-crm/locale";
import { Grid, Popover as MuiPopover } from "@material-ui/core";

import React, { ComponentProps } from "react";
import Button from "../../input/components/button";

type Props = {
  saveButtonDisabled?: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
} & ComponentProps<typeof MuiPopover>;

export const Popover = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children: popoverContent,
    saveButtonDisabled,
    onSubmit,
    onClose,
    ref: unusedRef,
    ...popoverProps
  } = props;

  return (
    <MuiPopover
      ref={ref}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      onClose={() => onClose && onClose()}
      PaperProps={{ style: { overflow: "initial" } }}
      {...popoverProps}
    >
      <Grid container style={{ gap: "0.5rem", padding: "1rem" }}>
        <Grid item xs={12}>
          {popoverContent}
        </Grid>
        {(onSubmit || onClose) && (
          <Grid
            item
            container
            xs={12}
            justifyContent="flex-end"
            style={{ gap: "0.5rem" }}
          >
            {onSubmit ? (
              <>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => onClose && onClose()}
                >
                  {locale.Cancel}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onSubmit && onSubmit()}
                  disabled={props.saveButtonDisabled}
                >
                  {locale.Save}
                </Button>
              </>
            ) : (
              onClose && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => onClose && onClose()}
                >
                  {locale.Close1}
                </Button>
              )
            )}
          </Grid>
        )}
      </Grid>
    </MuiPopover>
  );
});
